module.exports = __webpack_public_path__ + "static/media/experiment.e9e7f183.jpg";